import React, { useContext } from 'react';
import { Container, Row, Col, Table, Spinner, Form, InputGroup, Button } from 'react-bootstrap';
import { AppContext } from '../App';


export const ExpenseReport = () => {
	const { postCall, setGetLoad, getLoad, load, setLoad, getDate, expenseReport, setExpenseReport, expenseParti } = useContext(AppContext);
	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		let staff = e.target.staff.value;
		let partic = e.target.partic.value;
		if (start !== "" && end !== "") {
			setLoad(true)
			postCall('api/bnr/get/expense/report/', { start_date: start, end_date: end, staff_id: staff, p_id: partic }).then(res => {
				setExpenseReport(res.data);
				setLoad(false);
			}).catch(err => {
				setLoad(false);
			});
		}
	}
	return (
		<div className='container-fluid' >
			<div className='grid2by8 align-items-center bgp br-3 p-2 mb-2' >
				{
					load ? (
						<div className="d-grid py-2">
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						</div>
					) : (
						<span className='text-white' >Expense Report</span>
					)
				}
				<Form onSubmit={getReport} >
					<Row>
						<Col xs={12} sm={4} md={2} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={2} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="staff" className="shadow-none br-2">
								<option value="" >All staffs</option>
								{
									expenseReport !== undefined ? (
										expenseReport.users !== undefined ? (
											Object.keys(expenseReport.users).length > 0 ? (
												Object.keys(expenseReport.users).map((staff, staff_i) => (
													<option value={staff.substring(1)} key={`user_${staff_i}`} >{expenseReport.users[staff].username}</option>
												))
											) : ''
										) : ''
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="partic" className="shadow-none br-2">
								<option value="" >All Particulars</option>
								{
									expenseParti !== undefined && Object.keys(expenseParti).length > 0 ? (
										Object.keys(expenseParti).map((parti, pi) => (
											<option value={parti.substring(1)} key={`part_${pi}`} >{expenseParti[parti].name}</option>
										))
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={2} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>

			<Table bordered className="tbl-bg-blue" >
				<thead>
					<tr>
						<th className="tp2" >Particulars</th>
						<th className="tp2" >Remarks</th>
						<th className="tp2" >Staff</th>
						<th className="tp2" >Payment method</th>
						<th className="text-end tp2" >Amount</th>
					</tr>
				</thead>
				<tbody>
					{
						expenseReport !== undefined && Object.keys(expenseReport.expense_values).length > 0 ? (
							Object.keys(expenseReport.expense_values).map((exp, exi) => (
								<tr key={`exp_${exi}`} className="tc2" >
									<td>
										<span className="d-grid" >{expenseReport.expense_values[exp].particulars}</span>
									</td>
									<td>{expenseReport.expense_values[exp].remarks}</td>
									<td>{expenseReport.expense_values[exp].created_by}</td>
									<td>{expenseReport.expense_values[exp].payment_type}</td>
									<td className="text-end">{parseFloat(expenseReport.expense_values[exp].amount).toFixed(2)}</td>
								</tr>
							))
						) : ''
					}
					<tr>
						<td colSpan={3} className="text-end bgy"><span className="f20" >Total</span></td>
						<td className='bgy' >
							{
								expenseReport !== undefined && expenseReport.main.expense_total !== undefined && Object.keys(expenseReport.main.expense_total).length > 0 ? (
									Object.keys(expenseReport.main.expense_total).map((ex, exi) => (
										<div class="grid8by2 align-items-center bdr0-b py-1" key={`bpay_${exi}`} >
											<span className="tp2 f16" >{ex}</span>
											<div className='d-flex justify-content-end' >
												<span className="tp2 f16" >{parseFloat(expenseReport.main.expense_total[ex]).toFixed(2)}</span>
											</div>
										</div>
									))
								) : ''
							}
						</td>
						<td className="text-end bgy"><span className="f20" >{expenseReport !== undefined && expenseReport.main !== undefined ? parseFloat(expenseReport.main.total).toFixed(2) : ''}</span></td>
					</tr>
				</tbody>
			</Table>
		</div>
	)
}